import React from 'react';
import {Alert} from '@material-ui/lab';
import {Avatar, Box, Card, CardContent, CardHeader, List, ListItem, ListItemText} from "@material-ui/core";
import PauseIcon from '@material-ui/icons/Pause';
import setDate from "../../utils/setDate";

const VendorPauseCard = ({vendorPauses, cardClasses}) =>  (
    <Card component={Card} className={cardClasses.card}>
        <div>
            <CardHeader
                avatar={
                    <Avatar aria-label="type" className={cardClasses.contact}>
                        <PauseIcon/>
                    </Avatar>
                }
                title="Vendor Pauses"
                subheader={''}
            />
            <CardContent>
                {vendorPauses.length ? (
                    <List>
                        {vendorPauses.map(item => (
                            <ListItem key={item.id}>
                                <ListItemText style={{ borderBottom: '1px solid', paddingBottom: '10px'}}>
                                    <Box display={"flex"} flexDirection={"column"}>
                                        <Box style={{marginBottom: '10px'}}>
                                            <strong>Paused On:</strong> <strong><em>{item.pauseLevel} Level</em></strong>
                                        </Box>
                                        <Box style={{marginBottom: '10px'}}>
                                            <strong>Start Date:</strong> {item.startDate ? setDate(item.startDate) : 'N/A'}
                                        </Box>
                                        <Box>
                                            <strong>Expiration Date:</strong> {item.expiration ? setDate(item.expiration) : 'N/A'}
                                        </Box>
                                    </Box>
                                </ListItemText>
                            </ListItem>
                        ))}
                    </List>
                ) : (
                    <Alert severity="warning">Currently, this campaign has no vendor pauses</Alert>
                )}
            </CardContent>
        </div>
    </Card>
);

export default VendorPauseCard;
